import { render, staticRenderFns } from "./QuestionImportModule.vue?vue&type=template&id=6e1a1efb&"
import script from "./QuestionImportModule.vue?vue&type=script&lang=js&"
export * from "./QuestionImportModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports